import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label, Input, Alert
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData, Preview } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"
import moment from 'moment';
import 'moment/locale/id';

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'
import { apiRequest } from '../../../../../services/adapters/kepegawaian/koreksiKehadiranService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'

class DetailView extends Component {
    source
    createBloc = new CreateBloc();
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            selectedCorrectionType: 2,
            statusApproval: 0,
            detail: []
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.createBloc.fetchApprove(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    loadDetail = async () => {
        await this.indexBloc.fetchDetail({ uuid: this.props.uuid })
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }


    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response, selectedCorrectionType: result.data.response.attendance_correction_type })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.createBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
            isDownloading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
            isDownloading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    handleDownloadTemplate = () => {
        const detail = this.state.detail;
        if (!detail) return;

        const data = {
            params: {
                employee_uuid: detail.attendance_correction_employee_uuid,
                tanggal_koreksi: moment(detail.attendance_correction_date).format('YYYY-MM-DD'),
                attendance_correction_type_uuid: detail.attendance_correction_type_uuid,
                attendance_correction_category_uuid: detail.attendance_correction_category_uuid
            },
            responseType: 'blob'
        };

        this.setState({ isDownloading: true });
        apiRequest('get', 'Kepegawaian/koreksiKehadiran/downloadTemplate/', data)
            .then(response => {
                this.setState({ isDownloading: false });
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                const fileUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = fileUrl;
                const nipStr = detail.attendance_correction_employee_nip || "NIP";
                const tanggalKoreksi = moment(detail.attendance_correction_date).format('YYYY-MM-DD');
                link.setAttribute('download', `Format_Koreksi_Kehadiran_${nipStr}_${tanggalKoreksi}.docx`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }).catch(err => {
                this.setState({ isDownloading: false });
                console.error(err);
                alert('Gagal mengunduh template permohonan.');
            });
    }

    render() {
        const { detail } = this.state
        const correctionType = [
            { value: 2, label: 'Pribadi' },
            { value: 1, label: 'Dinas' },
        ]
        const adjustmentType = [
            { value: 1, label: 'Jam Masuk' },
            { value: 2, label: 'Jam Keluar' },
            { value: 3, label: 'Jam Masuk & Jam Keluar' },
        ]
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to='/izinpegawai/koreksikehadiran.html'>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Approval Pengajuan Koreksi Kehadiran</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    {detail?.info_description ? (
                                        <Alert color="info" role="alert">
                                            <div dangerouslySetInnerHTML={{ __html: detail.info_description }} />
                                        </Alert>
                                    ) : (
                                        <Alert color="info" role="alert">
                                            <p><strong>KOREKSI KEHADIRAN</strong></p>
                                        </Alert>
                                    )}
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mt-4 mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Pegawai
                                            </Label>
                                            <Col md="4">
                                                <Input
                                                    value={detail?.attendance_correction_employee_name ? `${detail.attendance_correction_employee_nip} - ${detail.attendance_correction_employee_name}` : ''}
                                                    type="text"
                                                    className="form-control"
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>

                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Kategori Alasan
                                                    </Label>
                                                    <Col md="4">
                                                        <Input
                                                            value={detail?.correction_type_categories_name || detail?.attendance_correction_note || ''}
                                                            type="text"
                                                            className="form-control"
                                                            disabled={true}
                                                        />
                                                        {detail?.correction_type_categories_description && (
                                                            <div className="mt-2 text-muted" style={{ fontSize: '0.9em' }}>
                                                                <strong>Keterangan Kategori:</strong> <br />
                                                                <span dangerouslySetInnerHTML={{ __html: detail.correction_type_categories_description }}></span>
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Tanggal Koreksi
                                                    </Label>
                                                    <Col md="4">
                                                        <Input
                                                            value={detail?.attendance_correction_date ? moment(detail.attendance_correction_date).locale('id').format('D MMMM YYYY') : ''}
                                                            type="text"
                                                            className="form-control"
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Jenis Koreksi
                                                    </Label>
                                                    <Col md="4">
                                                        <Input
                                                            value={detail?.correction_type_name || ''}
                                                            type="text"
                                                            className="form-control"
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </Row>

                                                {detail?.attendance_correction_adjustment_type && (
                                                    <Row className="mb-3">
                                                        <Label className="col-md-2 col-form-label">
                                                            Perbaikan Jam Cuti
                                                        </Label>
                                                        <Col md="4">
                                                            <Input
                                                                value={detail?.attendance_correction_adjustment_type_name || ''}
                                                                type="text"
                                                                className="form-control"
                                                                disabled={true}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}

                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Uang Makan
                                                    </Label>
                                                    <Col md="4">
                                                        <Input
                                                            value={detail?.attendance_correction_type_name || (detail?.attendance_correction_type == 2 ? 'Dibayar' : 'Tidak Dibayar')}
                                                            type="text"
                                                            className="form-control"
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </Row>

                                                {detail?.attendance_correction_letter_number && detail.attendance_correction_letter_number.length !== 0 && (
                                                    <Row className="mb-3">
                                                        <Label className="col-md-2 col-form-label">
                                                            Nomor Surat Dinas
                                                        </Label>
                                                        <Col md="4">
                                                            <Input
                                                                value={detail?.attendance_correction_letter_number}
                                                                type="text"
                                                                className="form-control"
                                                                disabled={true}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}

                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Dokumen Pendukung
                                                    </Label>
                                                    <Col md="4">
                                                        <Preview col="12" value={detail?.document} />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">
                                                        Dokumen Permohonan
                                                    </Label>
                                                    <Col md="4">
                                                        <Preview col="12" value={detail?.document_request} />
                                                    </Col>
                                                </Row>
                                        <hr className="my-4" />
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Status Approval <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    name="attendance_correction_approval_status"
                                                    type="text"
                                                    options={[
                                                        { value: 1, label: 'Disetujui' },
                                                        { value: 2, label: 'Ditolak' }
                                                    ]}
                                                    onChange={opt => this.setState({ statusApproval: opt.value })}
                                                    className="form-control"
                                                    defaultValue={this.state.statusApproval}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Catatan Approval
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="attendance_correction_approval_note"
                                                    placeholder="Catatan Approval"
                                                    type="textarea"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <Link to='/izinpegawai/koreksikehadiran.html'>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to={`/izinpegawai/koreksikehadiran.html`} />
                    : null}



            </Fragment>
        )
    }




}

export default withRouter(DetailView);